  function showRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').style.display = 'block';
    document.getElementById('CustomerLoginForm').style.display='none';
  }

  function hideRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').style.display = 'none';
    document.getElementById('CustomerLoginForm').style.display = 'block';
  }

  // Allow deep linking to the recover password form
  if (window.location.hash == '#recover') { showRecoverPasswordForm() }

  // reset_success is only true when the reset form is
  
  
  // Initialize observers on address selectors
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  
  // Setup province selector on each customer address
  $('.edit_add').each(function() {
    var formId = $(this).attr('data-form-id');
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`,
    });
  })
  
  Shopify.CustomerAddress = {
    toggleForm: function(id) {
      var editEl = document.getElementById('EditAddress_'+id);
      editEl.style.display = editEl.style.display == 'none' ? '' : 'none';
      return false;
    },

    toggleNewForm: function() {
      var el = document.getElementById('AddressOne');
      el.style.display = el.style.display == 'none' ? '' : 'none';
      return false;
    },
    destroy: function(id, confirm_msg) {
      if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
        Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
      }
    }
  }

  $('.changeaddress').click(function (e) {
    e.preventDefault();
    if($(this).hasClass('active')) {
      $('.editformClass').slideUp();
      $('.changeaddress').removeClass('active');
    } else {
      $('.changeaddress').removeClass('active');
      $(this).addClass('active');
      var x = $(this).closest('.editbuttonClass').data('id');
      
      $('.editformClass').slideUp();
      $('.editformClass.'+x).slideDown(function(){
        $('html, body').animate({
          scrollTop: $("."+x).offset().top
        }, 1000);
      });
    }
  });
  $('.cancel_form').click(function(){
    $('.editformClass').fadeOut('slow');
  });